.actions-item-wrapper {
  display: flex;
  align-items: center;
}

.actions-checkbox {
  width: 250px;
  display: inline;
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.actions-dropdown {
  display: inline;
}
